import { BREAKPOINTS, BREAKPOINTS_MEDIA, ImageBreakpointSrcSetSizes, ImageSrcSetSizes } from './Image.type';

export const breakpointsToSrcSet = (breakpointSpecs: ImageBreakpointSrcSetSizes): ImageSrcSetSizes => {
  const result: ImageSrcSetSizes = [];

  // Loop through the breakpoints in reverse order to ensure larger breakpoints come first
  // This ensures CSS media queries are ordered from largest to smallest for proper evaluation
  [...BREAKPOINTS].reverse().forEach((breakpoint) => {
    const breakpointSingleSpec = breakpointSpecs.find((value) => value[0] === breakpoint);
    if (breakpointSingleSpec) {
      const mediaQuery = BREAKPOINTS_MEDIA.get(breakpointSingleSpec[0]);
      if (mediaQuery) {
        result.push(
          [`(${mediaQuery})`, breakpointSingleSpec[1]],
          [`(${mediaQuery} and min-resolution: 2x)`, breakpointSingleSpec[1] * 2],
        );
      } else {
        // Case for default size
        result.push(['', breakpointSingleSpec[1]], [`(min-resolution: 2x)`, breakpointSingleSpec[1] * 2]);
      }
    }
  });

  return result;
};
